module.exports = __webpack_public_path__ + "static/media/eventInvestigacion.502f84f6.png";